import {
  Component,
  OnInit,
  Input,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { Order } from '../../../../shared/objects/order/order';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';
import { CommonUtils } from '../../../../shared/utils/common.utils';
import { ConfirmationResult } from '../../../../shared/objects/enum/confirm-result';
import { TimeslotBookingComponent } from '../timeslot-booking/timeslot-booking.component';
import { TimeslotType } from '../../../../shared/objects/enum/timeslotType';
import { OrderService } from '../shared/order.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OrderAcceptDeclineService } from '../shared/order-accept-decline.service';
import { OrderNotificationService } from '../shared/order-notification.service';
import { OrderStatus } from '../../../../shared/objects/enum/orderStatus';
import { ModalService } from '../../../../core/services/modal.service';
import { ResponsivenessService } from '../../../../core/services/responsiveness.service';
import { GlobalResponsivenessService } from '../../../../core/services/global-responsiveness.service';
import { MatTooltip as MatTooltip } from '@angular/material/tooltip';
import { EquipmentTypeEnum } from '../../admin/carriers/shared/equipment-type.enum';
import { ProductGradeEnum } from '../../admin/carriers/shared/product-grade.enum';
import { TooltipConfig } from '../../freight-exchange/shared/tooltip-config';
import { TooltipConfigModel } from '../../freight-exchange/shared/tooltip-config.model';
import { AuthService } from '../../../../core/services/auth.service';

@Component({
    selector: 'cp-order-header',
    templateUrl: './order-header.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./order-header.component.css'],
    standalone: false
})
export class OrderHeaderComponent implements OnInit, OnChanges {
  @Input() order: any;
  @Input() enableBookingFunction: boolean;
  @Input() enableAcceptRejectFunction: boolean;
  @Input() showLoadingDetails: boolean;
  @Input() showDeliveryDetails: boolean;
  @Input() showFreightExchangeDetails: boolean;
  @Input() handleOrderChange: () => void;
  @Input() toggleFade: () => void;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop = false;
  isDesktop1 = false;
  isDesktop2 = false;
  isLandscapeMobile = false;
  isPortraitTablet = false;
  isLandscapeTablet = false;
  public TooltipConfig = TooltipConfig;
  public columnsToDisplay = [
    'status',
    'orderId',
    'product',
    'salesNr',
    'reference',
  ];

  tooltipPosition = 'below';
  public orderDatasource: MatTableDataSource<Order>;

  get CommonUtils(): CommonUtils {
    return CommonUtils;
  }
  get isImpersonated() {
    return this.authService.isImpersonated();
  }
  constructor(
    private modalService: ModalService,
    private orderService: OrderService,
    private acceptDeclineOrderService: OrderAcceptDeclineService,
    private orderNotificationService: OrderNotificationService,
    private responsiveService: ResponsivenessService,
    private globalResponsive: GlobalResponsivenessService,
    private authService: AuthService,
  ) {
    this.orderDatasource = new MatTableDataSource<Order>();
    this.enableBookingFunction = false;
    this.showLoadingDetails = false;
    this.showDeliveryDetails = false;
    this.enableAcceptRejectFunction = false;
    var attributes = this.globalResponsive.getResolutionAttributes();
    this.isTablet = attributes.isTablet;
    this.isMobile = attributes.isMobile;
    this.isDesktop = attributes.isDesktop;
    this.isDesktop1 = attributes.isDesktop1;
    this.isDesktop2 = attributes.isDesktop2;
    this.isLandscapeTablet = attributes.isLandscapeTablet;
    this.isPortraitTablet = attributes.isPortraitTablet;
    this.isLandscapeMobile = attributes.isLandscapeMobile;
  }

  ngOnInit() {
    this.orderDatasource.data = [this.order];
    this.setupColumnsToDisplay(this.columnsToDisplay);
    this.globalResponsive.isMobile$.subscribe(
      isMobile => (this.isMobile = isMobile),
    );
    this.globalResponsive.isTablet$.subscribe(
      isTablet => (this.isTablet = isTablet),
    );
    this.globalResponsive.isPortraitTablet$.subscribe(isPortrait => {
      this.isLandscapeTablet = !isPortrait;
      this.isPortraitTablet = isPortrait;
    });

    this.globalResponsive.isLandscapeMobile$.subscribe(
      isLandscape => (this.isLandscapeMobile = isLandscape),
    );
    this.globalResponsive.isDesktop$.subscribe(
      isDesktop => (this.isDesktop = isDesktop),
    );
    this.globalResponsive.isDesktop2$.subscribe(
      isDesktop2 => (this.isDesktop2 = isDesktop2),
    );
    this.globalResponsive.isDesktop1$.subscribe(
      isDesktop1 => (this.isDesktop1 = isDesktop1),
    );
  }

  ngOnChanges() {
    this.orderDatasource.data = [this.order];
  }

  setupColumnsToDisplay(columnsDef: string[]): void {
    if (this.showBothLoadingAndDeliveryDetails()) {
      columnsDef.push('loading&delivPl');
      columnsDef.push('loading&deliveryDate');
    } else if (this.showOnlyLoadingDetails()) {
      columnsDef.push('loadingPl');
      columnsDef.push('loadingDate');
    } else if (this.showOnlyDeliveryDetails()) {
      columnsDef.push('delivPl');
      columnsDef.push('deliveryDate');
    }
    if (this.enableBookingFunction) {
      columnsDef.push('loading&delivTS');
    }
    if (this.enableAcceptRejectFunction) {
      columnsDef.push('acceptReject');
    }
    if (this.showFreightExchangeDetails) {
      const freightExchangeColumns = [
        'loadingPostalCodeCountry',
        'deliveryPostalCodeCountry',
        'loadingDate',
        'deliveryDate',
        'productGrade',
        'productType',
        'product',
        'quantity',
        'targetPrice',
        'bidPrice',
      ];

      this.columnsToDisplay = [...freightExchangeColumns];
    }
  }

  formatPlaceMobile(text = '') {
    if (this.isMobile) {
      const textArr = text.split(', ');
      const city = textArr.shift();
      text = [...textArr, city].join(', ');
    }
    return text;
  }
  formatPlaceText(
    text: string,
    tooltipConfig: TooltipConfigModel = TooltipConfig.placeConfig,
  ): string {
    this.formatMobile(text);

    if (this.isDesktop2) {
      return TooltipConfig.getTooltipSmallDesktopList(text, tooltipConfig);
    } else if (this.isDesktop1) {
      return TooltipConfig.getTooltipSmallDesktop(text, tooltipConfig);
    } else if (this.isPortraitTablet) {
      return TooltipConfig.getTooltipTabletPortrait(text, tooltipConfig);
    } else if (this.isLandscapeTablet) {
      return TooltipConfig.getTooltipTabletLandscape(text, tooltipConfig);
    } else if (this.isDesktop) {
      return TooltipConfig.getTooltipDesktopList(text, tooltipConfig);
    } else {
      return TooltipConfig.getTooltipOther(text, tooltipConfig);
    }
  }
  formatProductGrade(productGrade: number): string {
    const productGradeStr = ProductGradeEnum[productGrade];
    if (!!productGradeStr) {
      return 'PRODUCT-GRADE.' + productGradeStr.toUpperCase();
    }
    return '';
  }
  showOnlyLoadingDetails(): boolean {
    return this.showLoadingDetails && !this.showDeliveryDetails;
  }

  showOnlyDeliveryDetails(): boolean {
    return !this.showLoadingDetails && this.showDeliveryDetails;
  }

  showBothLoadingAndDeliveryDetails(): boolean {
    return this.showLoadingDetails && this.showDeliveryDetails;
  }

  canBookLoadingTimeslot() {
    const maxLoading = new Date(this.order.maxLoadingDateTime.toString());
    const now = new Date();
    if (maxLoading < now) return false;
    return true;
  }
  canBookDeliveryTimeslot() {
    const maxDelivery = new Date(this.order.maxDeliveryDateTime.toString());
    const now = new Date();
    if (maxDelivery < now) return false;
    return true;
  }

  openLoadingTimeslotBooking(): void {
    if (this.canBookLoadingTimeslot()) {
      const loadingTimeslotModelRef = this.modalService.open(
        TimeslotBookingComponent,
        {
          windowClass: 'modal-loading-m',
          container: '#AppContent',
          keyboard: false,
          backdrop: 'static',
        },
      );
      this.toggleFade();
      loadingTimeslotModelRef.componentInstance.order = this.order;
      loadingTimeslotModelRef.componentInstance.timeslotType =
        TimeslotType.Loading;
      loadingTimeslotModelRef.componentInstance.modalRefItself =
        loadingTimeslotModelRef;
      loadingTimeslotModelRef.result.catch(() => {
        this.handleOrderChange();
        this.toggleFade();
        this.closeContextModal();
      });
    } else {
      this.orderNotificationService.showTimeslotBookingErrorMessage();
    }
  }

  openDeliveryTimeslotBooking(): void {
    if (this.canBookDeliveryTimeslot()) {
      const deliveryTimeslotModelRef = this.modalService.open(
        TimeslotBookingComponent,
        {
          windowClass: 'modal-loading-m',
          container: '#AppContent',
          keyboard: false,
          backdrop: 'static',
        },
      );
      this.toggleFade();
      deliveryTimeslotModelRef.componentInstance.order = this.order;
      deliveryTimeslotModelRef.componentInstance.timeslotType =
        TimeslotType.Delivery;
      deliveryTimeslotModelRef.componentInstance.modalRefItself =
        deliveryTimeslotModelRef;
      deliveryTimeslotModelRef.result.catch(() => {
        this.handleOrderChange();
        this.toggleFade();
        this.closeContextModal();
      });
    } else {
      this.orderNotificationService.showTimeslotBookingErrorMessage();
    }
  }

  orderCanBeAcceptedOrRejected() {
    return (
      (!!this.order &&
        this.order.status === OrderStatus.AnnouncedToCarrier.toString()) ||
      this.order.status === OrderStatus.TimeExpired.toString()
    );
  }

  orderIsRejected() {
    return (
      !!this.order && this.order.status === OrderStatus.CarrierDenied.toString()
    );
  }

  formatMobile(name: string): string {
    if (this.isMobile || this.isTablet) {
      return name.length > 30 ? `${name.substr(0, 30)}...` : name;
    }
    return name;
  }

  // TODO: Try to encapsulate the confirm/deny order(s) in the order-accept-decline service from header and order list
  confirmAcceptOrder() {
    if (!!this.order.dossierId && this.order.dossierId !== 0) {
      this.orderService
        .getDossierOrdersBy(this.order.dossierId)
        .then(orderIds => {
          const modal: NgbModalRef =
            this.acceptDeclineOrderService.showconfirmAcceptDossierOrder(
              orderIds,
            );
          this.toggleFade();
          modal.componentInstance.optionChoosed.subscribe(answer => {
            this.processOrderAcceptanceAnswer(+this.order.id, answer, true);
            this.toggleFade();
            this.closeContextModal();
          });
          modal.result.catch(() => {
            this.toggleFade();
            this.closeContextModal();
          });
        });
    } else {
      const modal: NgbModalRef =
        this.acceptDeclineOrderService.showconfirmAcceptOrder(+this.order.id);
      this.toggleFade();
      modal.componentInstance.optionChoosed.subscribe(answer => {
        this.processOrderAcceptanceAnswer(+this.order.id, answer, false);
        this.toggleFade();
        this.closeContextModal();
      });
      modal.result.catch(() => {
        this.toggleFade();
        this.closeContextModal();
      });
    }
  }

  confirmRejectOrder() {
    if (!!this.order.dossierId && this.order.dossierId !== 0) {
      this.orderService
        .getDossierOrdersBy(this.order.dossierId)
        .then(orderIds => {
          const modal: NgbModalRef =
            this.acceptDeclineOrderService.showconfirmRejectDossierOrder(
              orderIds,
            );
          this.toggleFade();
          modal.componentInstance.optionChoosed.subscribe(answer => {
            this.processOrderDeclineAnswer(+this.order.id, answer, true);
            this.toggleFade();
            this.closeContextModal();
          });
          modal.result.catch(() => {
            this.toggleFade();
            this.closeContextModal();
          });
        });
    } else {
      const modal: NgbModalRef =
        this.acceptDeclineOrderService.showconfirmRejectOrder(+this.order.id);
      this.toggleFade();
      modal.componentInstance.optionChoosed.subscribe(answer => {
        this.processOrderDeclineAnswer(+this.order.id, answer, false);
        this.toggleFade();
        this.closeContextModal();
      });
      modal.result.catch(() => {
        this.toggleFade();
        this.closeContextModal();
      });
    }
  }

  processOrderAcceptanceAnswer(
    orderId: number,
    result: ConfirmationResult,
    isDossierOrder: boolean,
  ) {
    if (result === ConfirmationResult.Confirmed) {
      this.acceptOrder(orderId, isDossierOrder);
    }
  }

  processOrderDeclineAnswer(
    orderId: number,
    result: ConfirmationResult,
    isDossierOrder: boolean,
  ) {
    if (result === ConfirmationResult.Confirmed) {
      this.declineOrder(orderId, isDossierOrder);
    }
  }

  acceptOrder(orderId: number, isDossierOrder: boolean) {
    this.orderService.acceptOrder(orderId).then(
      _ => {
        this.handleOrderChange();
        if (isDossierOrder) {
          this.orderNotificationService.showDossierOrderAcceptedMessage();
        } else {
          this.orderNotificationService.showOrderAcceptedMessage();
        }
      },
      error => {
        if (isDossierOrder) {
          this.orderNotificationService.showDossierOrderAcceptedRejectedMessageFailure();
        } else {
          this.orderNotificationService.showOrderAcceptedRejectedFailureMessage();
        }
      },
    );
  }

  declineOrder(orderId: number, isDossierOrder: boolean) {
    this.orderService.denyOrder(orderId).then(
      _ => {
        this.handleOrderChange();
        if (isDossierOrder) {
          this.orderNotificationService.showDossierOrderDeclinedMessage();
        } else {
          this.orderNotificationService.showOrderDeclinedMessage();
        }
      },
      error => {
        if (isDossierOrder) {
          this.orderNotificationService.showDossierOrderAcceptedRejectedMessageFailure();
        } else {
          this.orderNotificationService.showOrderAcceptedRejectedFailureMessage();
        }
      },
    );
  }

  get orderCurrencySymbol(): string {
    if (!this.order) {
      return '';
    }
    return this.orderService.orderCurrencySymbol(this.order.currencyId);
  }

  formatText(data: string): string {
    if (this.isMobile) {
      if (this.isLandscapeMobile) {
        return CommonUtils.formatTextLandscapeMobile(data);
      }
      return CommonUtils.formatTextPortraitMobile(data);
    } else if (this.isTablet) {
      if (this.isLandscapeTablet) {
        return CommonUtils.formatTextLandscapeTablet(data);
      }
      return CommonUtils.formatTextPortraitTablet(data);
    } else {
      return CommonUtils.formatTextDesktop(data);
    }
  }
  formatTooltipText(text: string, tooltipConfig: TooltipConfigModel): string {
    if (this.isDesktop1 || this.isDesktop2) {
      return TooltipConfig.getTooltipSmallDesktopList(text, tooltipConfig);
    } else if (this.isDesktop) {
      return TooltipConfig.getTooltipDesktop(text, tooltipConfig);
    } else {
      return TooltipConfig.getTooltipOther(text, tooltipConfig);
    }
  }
  formatProduct(
    text,
    tooltipConfig: TooltipConfigModel = TooltipConfig.productConfig,
  ) {
    if (this.isMobile) {
      if (this.isLandscapeMobile) {
        return CommonUtils.formatTextLandscapeMobile(text);
      }
      return CommonUtils.formatTextPortraitMobile(text);
    } else if (this.isTablet) {
      if (this.isLandscapeTablet) {
        return CommonUtils.formatTextLandscapeTablet(text);
      }
      return CommonUtils.formatTextPortraitTablet(text);
    } else {
      return this.formatTooltipText(text, tooltipConfig);
    }
  }
  getProduct(text: string) {
    const formatted = this.formatProduct(text.trim());

    if (text.trim() !== formatted) return `${text}`;
    return null;
  }
  getProductType(text: string) {
    const formatted = this.formatProduct(
      text.trim(),
      TooltipConfig.productTypeConfig,
    );

    if (text.trim() !== formatted) return `${text}`;
    return null;
  }

  getLoadingDeliveryPlace(element) {
    const formattedLoadingPl = this.formatText(element.loadingPl.trim());
    const formattedDeliveryPl = this.formatText(element.delivPl.trim());
    if (
      element.loadingPl.trim() !== formattedLoadingPl ||
      element.delivPl.trim() !== formattedDeliveryPl
    )
      return `${element.loadingPl} | ${element.delivPl}`;
    return null;
  }
  public toggleTooltip(tooltip: MatTooltip): void {
    tooltip.toggle();
  }

  getLoadingDeliveryRef(element) {
    if (
      element.loadingReference.trim() !==
        this.formatText(element.loadingReference.trim()) ||
      element.deliveryReference.trim() !==
        this.formatText(element.deliveryReference.trim())
    )
      return `${element.loadingReference} | ${element.deliveryReference}`;
    return null;
  }

  private closeContextModal(): void {
    this.modalService.close();
  }
}
